import React from 'react';
import PropTypes from 'prop-types';

const SmallTalk = ({ color }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M21 4.48676C21 3.66691 20.3331 3 19.5132 3H9.74648C8.92664 3 8.25955 3.66691 8.25955 4.48676V9.20473H4.48711C3.66709 9.20473 3 9.87199 3 10.6918V20.64C3 20.7855 3.08771 20.917 3.22219 20.9726C3.26684 20.9912 3.31359 21 3.36 21C3.45369 21 3.54563 20.9634 3.61453 20.8945L6.12434 18.3847H14.2521C15.0721 18.3847 15.7392 17.7175 15.7392 16.8976V12.18H17.8774L20.3855 14.688C20.4544 14.757 20.5463 14.7935 20.64 14.7935C20.6864 14.7935 20.7332 14.7847 20.7778 14.7661C20.9123 14.7105 21 14.5791 21 14.4335V4.48676ZM15.0192 16.8976C15.0192 17.3205 14.675 17.6647 14.2521 17.6647H5.97527C5.87982 17.6647 5.78824 17.7027 5.72074 17.7702L3.72 19.7709V10.6918C3.72 10.2689 4.06418 9.92473 4.48711 9.92473H8.61085C8.61393 9.92481 8.61645 9.92648 8.61955 9.92648C8.62265 9.92648 8.62518 9.92481 8.62825 9.92473H14.2521C14.675 9.92473 15.0192 10.2689 15.0192 10.6918V16.8976ZM20.28 13.5645L18.281 11.5655C18.2135 11.498 18.1219 11.46 18.0265 11.46H15.7392V10.6918C15.7392 9.87199 15.0721 9.20473 14.2521 9.20473H8.97955V4.48676C8.97955 4.06383 9.32355 3.72 9.74648 3.72H19.5132C19.936 3.72 20.28 4.06383 20.28 4.48676V13.5645Z"
          fill={color}
          stroke={color}
        />
        <path
          d="M13.44 12.084H5.29921C5.1004 12.084 4.93921 12.245 4.93921 12.444C4.93921 12.643 5.1004 12.804 5.29921 12.804H13.44C13.6388 12.804 13.8 12.643 13.8 12.444C13.8 12.245 13.6388 12.084 13.44 12.084Z"
          fill={color}
          stroke={color}
          strokeWidth="0.5"
        />
        <path
          d="M13.44 14.7842H5.29921C5.1004 14.7842 4.93921 14.9452 4.93921 15.1442C4.93921 15.3432 5.1004 15.5042 5.29921 15.5042H13.44C13.6388 15.5042 13.8 15.3432 13.8 15.1442C13.8 14.9452 13.6388 14.7842 13.44 14.7842Z"
          fill={color}
          stroke={color}
          strokeWidth="0.5"
        />
      </g>
    </svg>
  );
};

SmallTalk.propTypes = {
  color: PropTypes.string,
};
export default SmallTalk;
